"use strict";
document.addEventListener('DOMContentLoaded', function(){
  deleteAllCookies();

  if(sessionStorage.getItem("confirmed") && (sessionStorage.getItem('confirmed') == 'true')) {
    document.querySelector('.notice').classList.add("confirmed");
  }

  let noticeBtn = document.querySelector('.notice__btn');
  noticeBtn.addEventListener('click', function() {
    document.querySelector('.notice').classList.add("confirmed");
    sessionStorage.setItem('confirmed', 'true');
  });
  if(window.innerWidth <= 768) {
    document.querySelector(".header-li__items").style.height = window.innerHeight - (100 / 2) + "px";
  }
});
window.addEventListener('load', function() {
  document.querySelector(".container").classList.add("loaded");
});
document.querySelectorAll(".header-menu, .header-links").forEach(target => {
  target.addEventListener("click", () => {
    document.querySelector(".header").classList.toggle("is-header-active");
  });
});

/**
 * アコーディオン
 *
 */
const accordionTrigger = document.querySelectorAll(".js-accordion");
for (let i = 0; i < accordionTrigger.length; i++) {
  // トリガーを押した時のアクション
  let accordionTargetisOpened = false;
  accordionTrigger[i].addEventListener("click", function(e) {
    // クリックされた要素（トリガー要素）を取得
    let currentElement = e.currentTarget;
    // 同じ親要素を持つ隣接した次の要素'.js-accordion'（展開対象の要素）を取得

    let accordionTarget = currentElement.nextElementSibling;
    if(currentElement.classList.contains("header-nav")) {
      accordionTarget = document.querySelector(".header__inner");
    }
    if(currentElement.classList.contains("header-list__ttl")) {
      var allHeaderList = document.querySelectorAll(".header-list__ttl");
      for(var i = 0; i < allHeaderList.length; i++) {
        if(allHeaderList[i].classList.contains("is-active-trigger")) {
          allHeaderList[i].classList.remove("is-active-trigger");
          allHeaderList[i].nextElementSibling.classList.remove("is-active");
        }
      }
    }

    if (accordionTargetisOpened) {
      //トリガーの'is-active'クラスを削除
      currentElement.classList.remove("is-active-trigger");
      accordionTarget.classList.remove("is-active");
      accordionTargetisOpened = false;
    } else {
      //トリガーの'is-active'クラスを追加
      currentElement.classList.add("is-active-trigger");
      accordionTarget.classList.add("is-active");
      accordionTargetisOpened = true;
    }
  });
}


/*
 * クッキー削除
*/
function deleteAllCookies() {
  const cookies = document.cookie.split(';')
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i]
    const eqPos = cookie.indexOf('=')
    const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie
    document.cookie = name + '=;max-age=0'
  }
}



